<template>
  <div class="login">
    <el-form :model="input_user" :rules="rules" ref="input_user"
              label-position="left" label-width="0px"
              class="demo-ruleForm login-container">
      <!-- logo -->
      <div class="logo text-center">
          <img id="ul_login_Image2" src="" class="logoimg">
      </div>
      <!-- 小蜜蜂 -->
      <div class="bee">
          <img src="./imgs/bee.png" class="beeimg">
      </div>

      <el-form-item prop="username">
        <el-input type="text"  placeholder="请输入手机号码" v-model="input_user.username"></el-input>
      </el-form-item>

      <get-verify-code class="showyanzhengma" :username='input_user.username'></get-verify-code>

      <el-form-item prop="password">
        <el-input type="password"  class="showmimainput hide" placeholder="请输入密码" v-model="input_user.password"  auto-complete="off"  ></el-input>
      </el-form-item>

      <span class="showmimaspan  rf12" @click="showmimadd">点击切换成密码登录</span>
      <span class="showyanzhengmaspan hide rf12"  @click="showyanzhengmadd">点击切换成验证码登录</span>

      <!-- <el-form-item style="height:35px" class="showmima hide">
        <router-link
            class="cf-left yellcolor"
            to="/forget">忘记密码?
        </router-link>
        <router-link
            class="cf-right yellcolor"
            to="/register">立即注册&nbsp;
        </router-link>
      </el-form-item> -->

      <el-form-item  class="showyanzhengma" style="width:100%;">
        <el-button  type="primary" style="width:100%;margin-top:10px;"
                    @click.stop.prevent="user_login"
                    >登录
        </el-button>
      </el-form-item>

      <el-form-item  class="showmima hide" style="width:100%;">
        <el-button  type="primary" style="width:100%; margin-top:10px;"
                    @click.stop.prevent="user_loginmima"
                    >登录
        </el-button>
      </el-form-item>
        <div style="font-size: 11px;color: #bdbdbd;padding-top: 5px">
          <a>未注册的用户验证码登录后将为您自动创建账号，登录即代表您同意必胜公考</a>
          <a href="http://h5.platform.winlesson.com/e/de?" target="_blank">《隐私政策》</a>
          <a>和</a>
          <a href="https://h5.platform.winlesson.com/e/ae?" target="_blank">《用户协议》</a>
        </div>
    </el-form>
  </div>
</template>

<script>
import GetVerifyCode from './GetVerifyCode'
export default {
    name: "login",
    computed: {
      user() {
        return this.$store.state.user;
      }
    },
    components: {
      GetVerifyCode
    },
    data() {
      return {
        input_user: {
          username: '',
          verify_code: '',
          password: '',
        },
        rules: {
          username: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
             //{ pattern: /^1\d{10}$/, message: '手机号格式错误', trigger: 'blur'}
          ],
          // password: [
          //   { required: true, message: '请输入密码', trigger: 'blur' },
          // ],
        }
      }
    },

    watch: {
      user: {
        handler: function(val, oldVal) {
          if (val.user_id && val.user_id != '') {
            this.$router.go(-1)
          }
        },
        deep: true
      }
    },
    created: function() {
       var context = this;
       var domain = window.location.host;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
       // if(domain=='localhost:8080'){
          var application_id = 300;
          context.$store.dispatch('update_application', application_id);
       }else{
          var application_id = 1;
          context.$store.dispatch('update_application', application_id);
       }
    },
    methods: {
      user_login() {//验证码
        this.$refs.input_user.validate((valid) => {
          if (valid) {
            if (this.input_user.verify_code=='') {
                alert('请输入验证码');
            }
            this.$store.dispatch('userLogin', this.input_user)
          } else {
            return false;
          }
        });

      },
      user_loginmima() {//密码登录
         $(".showmima").removeClass('hide');
        this.$refs.input_user.validate((valid) => {
          if (valid) {
            if (this.input_user.password=='') {
                alert('请输入密码');
            }
            this.$store.dispatch('userLoginmima', this.input_user)

          } else {
            return false;
          }
        });

      },
      setVerifyCode(val) {
        this.input_user.verify_code = val;
      },
      showmimadd() {
        $(".showmima").removeClass('hide');
        $(".showyanzhengma").addClass('hide');
        $(".showmimainput").removeClass('hide');

        $(".showmimaspan").addClass('hide');
        $(".showyanzhengmaspan").removeClass('hide');
      },
      showyanzhengmadd() {
        $(".showmima").addClass('hide');
        $(".showyanzhengma").removeClass('hide');
        $(".showmimainput").addClass('hide');

        $(".showmimaspan").removeClass('hide');
        $(".showyanzhengmaspan").addClass('hide');
      },
    }
}
</script>

<style scoped>
 @import "../../common/style/login.css";
 .hide{
  display:none;
 }
 .rf12{
  font-size: 14px;
  color: #fcb200;
  margin-bottom:5px;
cursor: pointer;
 }
 .mt10{
    margin-top:10px;
 }
</style>



// WEBPACK FOOTER //
// src/components/Log/Login.vue